import { z } from 'zod';

// zod v4 API: literal принимает объект `{ error: '...' }`.

export const leadMagnetSchema = z.object({
  email: z
    .string()
    .min(3, 'Похоже на опечатку в email — проверьте')
    .email('Похоже на опечатку в email — проверьте'),
  consent: z.literal(true, {
    error: 'Без согласия на обработку данных отправить не получится',
  }),
});

export type LeadMagnetInput = z.infer<typeof leadMagnetSchema>;
